import { render } from "./SRaceView.vue?vue&type=template&id=2ba9fe55&scoped=true"
import script from "./SRaceView.vue?vue&type=script&lang=js"
export * from "./SRaceView.vue?vue&type=script&lang=js"

import "./SRaceView.vue?vue&type=style&index=0&id=2ba9fe55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba9fe55"]])

export default __exports__